import { render } from "./StepCurriculumItem.vue?vue&type=template&id=cf1893a0&scoped=true"
import script from "./StepCurriculumItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StepCurriculumItem.vue?vue&type=script&setup=true&lang=js"

import "./StepCurriculumItem.vue?vue&type=style&index=0&id=cf1893a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1893a0"],['__file',"src/components/Study/StepCurriculumItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf1893a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf1893a0', __exports__)) {
    api.reload('cf1893a0', __exports__)
  }
  
  module.hot.accept("./StepCurriculumItem.vue?vue&type=template&id=cf1893a0&scoped=true", () => {
    api.rerender('cf1893a0', render)
  })

}


export default __exports__